import React from 'react';
import Modal from '../../../../common/Modal';
import Button from '../../../../common/Button';
import { useTranslation } from 'react-i18next';

interface ResetUsageModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isSubmitting: boolean;
}

const ResetUsageModal: React.FC<ResetUsageModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  isSubmitting
}) => {
  const { t } = useTranslation();

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={t('Reset Usage Count')}
      className="w-full h-auto max-w-md"
    >
      <div className="py-4">
        <p className="text-stone-800 dark:text-zinc-300 mb-6">
          {t('Are you sure you want to reset the usage count to 0? This action cannot be undone.')}
        </p>
        <div className="flex justify-end space-x-3">
          <Button variant="cancel" onClick={onClose} type="button" disabled={isSubmitting}>
            {t('Cancel')}
          </Button>
          <Button variant="primary" onClick={onConfirm} type="button" disabled={isSubmitting}>
            {isSubmitting ? t('Processing...') : t('Reset Count')}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default ResetUsageModal;
